import { ExtensionBase } from "../extensionBase";
import { PdmsAttrPanel } from "./PdmsAttrPanel";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions } from "../../viewer";
import { UiUtils } from "../../common/uiUtils";
import * as SmartDrawings from "../../smartDrawings";

/**
 * An extension for viewing PDMS attributes.
 */
export class PdmsAttrExtension extends ExtensionBase {

    static extensionName = "PdmsAttrExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private panel: PdmsAttrPanel;
    private title: string;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);
    }

    static registerExtension() {
        // TODO remove source
        if (viewerOptions.tools.source === "pdms" || (viewerOptions.tools.modelSettingsId != null && viewerOptions.tools.modelSettingsId.indexOf("pdms.") === 0)) {
            super.registerExtension(PdmsAttrExtension.extensionName, PdmsAttrExtension);
        }
    }

    load(): boolean {
        console.log("PdmAttrExtension is loaded!");
        this.panel = new PdmsAttrPanel(this.viewer);
      
        return super.load();
    };

    unload(): boolean {
        this.viewer.getToolbar(false).removeControl(this.subToolbar);
        return super.unload();
    };

    onToolbarCreated(): void {
        const propertyButton = UiUtils.createButton({
            id: "SmartDrawings.PdmsAttrButton",
            tooltip: "PDMS attributes",
            iconClass: "ion-md-list-box",
            onClick: () => {
                this.panel.setVisible(!this.panel.isVisible());
                if (this.title) {
                    this.panel.setTitle(this.title, null);
                }
            }
        });

        this.panel.addVisibilityListener(visible => {
            propertyButton.setState(visible ? Autodesk.Viewing.UI.Button.State.ACTIVE : Autodesk.Viewing.UI.Button.State.INACTIVE);
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.subToolbar.addControl(propertyButton);
    }

    protected async onModelRootLoaded() {
        await this.setAttributes();
        await this.setModelStructureMapping();
    }

    private async setAttributes() {
        const { data } = await ModelApi.getPdmsAttr(viewerOptions.guid || viewerOptions.urn);
        this.panel.setAttributes(data);
        this.title = data.title;
    }

    private async setModelStructureMapping() {
        const { data } = await ModelApi.getModelTree(viewerOptions.guid);
        this.panel.setModelStructureMapping(data);
    }
}